export enum MigrationSource {
    PAYSTONE_HUB = 'paystone_hub',
}

export enum LanguagePreference {
    EN = 'en',
    FR = 'fr',
}
